// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { RerunIn } from './rerunIn.zod.ts';

export const IdeaResearchRerunApiIdeasIdeaIdResearchPostBody = zod.union([RerunIn,zod.null()])

export type IdeaResearchRerunApiIdeasIdeaIdResearchPostBody = zod.input<typeof IdeaResearchRerunApiIdeasIdeaIdResearchPostBody>;
export type IdeaResearchRerunApiIdeasIdeaIdResearchPostBodyOutput = zod.output<typeof IdeaResearchRerunApiIdeasIdeaIdResearchPostBody>;
